module.exports = __webpack_public_path__ + "img/banner_ep2.9400a22c.png";